<template>
  <v-tooltip top :disabled="!timePassed">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-on="{ ...on, ...$listeners }" v-bind="attrs" icon small>
        <v-icon small>mdi-refresh</v-icon>
      </v-btn>
    </template>

    <span>{{ timePassed }}</span>
  </v-tooltip>
</template>

<script>
import DateMixin from "@/mixins/DateMixin";

export default {
  mixins: [DateMixin],

  props: {
    time: {
      type: Date,
      default: null
    }
  },

  data() {
    return {
      timePassed: this.time ? this.formatDateTimeNow(this.time) : null
    };
  },

  created() {
    setInterval(() => {
      this.timePassed = this.time ? this.formatDateTimeNow(this.time) : null;
    }, 1000);
  }
};
</script>

<style></style>
